<template>
	<div>
		<!-- Headline -->
		<div slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("exclusions") }}
		</div>

		<j-card class="bg5">
			<j-list :list="computedList" v-if="computedList.length > 0">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex wrap xs-10 xs-left xs-middle fw7 lh125">
						<div class="xs-12 lh125 c1">{{ item.label }}</div>
						<div class="xs-12 fw4 c1 lh125">{{ item.remark }}</div>
					</div>
					<div class="flex xs-2 xs-right xs-middle lh125">
						<div v-if="hasActions">
							<crm-icon
								v-can="'writeQuotes'"
								name="delete"
								class="cu2"
								color="cError"
								size="small"
								@click.native="removeExclusion(item.id)"
							/>
						</div>
					</div>
				</div>
			</j-list>

			<!-- Add/update button -->
			<div class="xs-12 p3" v-if="hasActions">
				<div class="fs3 lh125 c1 mb2" v-if="computedList.length === 0">
					{{ $t("exclusion_is_empty") }}
				</div>
				<j-button
					v-can="'writeQuotes'"
					size="xsmall"
					@click="$modal.show('addExclusion')"
				>
					{{ $t("add_exclusion") }}
				</j-button>
			</div>

			<!-- Empty without actions -->
			<div
				v-if="computedList.length === 0 && !hasActions"
				class="fs3 c1 ta2 p2"
			>
				{{ $t("errors.no_data") }}
			</div>
		</j-card>

		<!-- Modal for adding loading -->
		<core-modal name="addExclusion" :headline="$t('add_exclusion')">
			<exclusions-create
				:policyId="policyId"
				:offerId="offerId"
				:productId="productId"
				@created="afterExclusionCreated"
				@cancelled="$modal.hide('addExclusion')"
			/>
		</core-modal>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import ExclusionsCreate from "./ExclusionsCreate"
import CoreModal from "@/modules/core/components/CoreModal"
import dayjs from "dayjs"
import get from "lodash.get"
import api from "../api/"

export default {
	components: {
		JCard,
		JList,
		JButton,
		CrmIcon,
		ExclusionsCreate,
		CoreModal
	},

	props: {
		policyId: {
			type: String,
			required: true,
			default: ""
		},

		offerId: {
			required: false,
			default: null
		},

		productId: {
			type: Object,
			required: true,
			default: () => ({
				plan: null,
				type: null,
				version: null
			})
		},

		hasActions: {
			type: Boolean,
			required: false,
			default: false
		},

		/**
		 * List of exclusions that we get from graphql
		 */
		list: {
			type: Array,
			required: false,
			default: () => [
				{
					id: null,
					codeName: {
						code: null,
						name: null
					},
					remark: null
				}
			]
		}
	},

	computed: {
		computedList() {
			return this.list.map(item => ({
				id: item.id,
				label: `${get(item, "codeName.code")} - ${get(item, "codeName.name")}`,
				remark: item.remark
			}))
		}
	},

	methods: {
		async removeExclusion(id) {
			// Based on if it's on offer or directly on policy
			const offerId = this.offerId ? this.offerId : null

			const res = await api.removeExclusion({
				policyId: this.policyId,
				offerId,
				exclusionId: id
			})

			// Check errors
			if (res.errors) this.$store.dispatch("showError", res.errors)

			// Emit
			this.$emit("deleted")
		},

		afterExclusionCreated() {
			this.$modal.hide("addExclusion")
			this.$emit("created")
		}
	}
}
</script>
